import clsx from 'clsx';

interface FallbackCardProps {
  title?: string;
  description?: string;
  icon?: string;
}

export const FallbackCard = ({
  title = 'No access',
  description = 'You do not have the permissions to view this page. ',
}: FallbackCardProps) => {
  return (
    <div
      className={clsx(
        ' w-full p-10 border dark:bg-blue-1000 dark:border-grey-700 bg-grey-200 border-grey-400 rounded-2xl flex gap-4'
      )}
    >
      <div className="grid px-4 bg-red-100 rounded-full place-items-center py-[15px] h-min">
        <span className="text-4xl text-red-600 heading-icon material-symbols-outlined">lock</span>
      </div>

      <div className="flex flex-col">
        {title && (
          <span className="flex gap-2 text-blue-1000 dark:text-blue-100 ">
            <h2 className="mb-2 text-3xl font-bold card-heading dark:text-blue-100">{title}</h2>
          </span>
        )}

        {description && (
          <p className="max-w-2xl dark:text-blue-100 text-grey-1000">{description}</p>
        )}
      </div>
    </div>
  );
};
